import cx from 'classnames'
import React, { Component } from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
require('./loading.css')

let div = null

class Toast extends Component {
  render() {
    let { title } = this.props
    let clz = cx('toast-icon', 'toast-icon-loading')
    return (
      <div class="toast-bg">
        <div class={clz} />
        <div class="toast-content">{title}</div>
      </div>
    )
  }
}

export default function ({ title = '加载中' } = {}) {
  if (div) return
  div = document.createElement('div')
  div.className = 'modal'
  if (title) {
    let toast = React.createElement(Toast, {
      title
    })
    render(toast, div)
    div.style.backgroundColor = 'transparent'
  }
  document.body.appendChild(div)
  return function () {
    if (!div) return
    div.parentNode.removeChild(div)
    unmountComponentAtNode(div)
    div = null
  }
}
